"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useForm = useForm;
exports.useKeyHack = useKeyHack;
exports.useMeasure = useMeasure;
exports.useOutsideClick = useOutsideClick;
exports.useToggle = exports.useSwitch = void 0;
exports.useWindowWidth = useWindowWidth;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _global = _interopRequireDefault(require("global"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function useMeasure(update) {
  var ref = (0, _react.useRef)();
  var _useState = (0, _react.useState)({}),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    bounds = _useState2[0],
    set = _useState2[1];
  (0, _react.useEffect)(function () {
    return ref.current && set(ref.current.getBoundingClientRect());
  }, [update]);
  return [ref, bounds];
}
function useWindowWidth() {
  var _useState3 = (0, _react.useState)(_global["default"].innerWidth),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    width = _useState4[0],
    setWidth = _useState4[1];
  (0, _react.useEffect)(function () {
    var handleResize = function handleResize() {
      return setWidth(_global["default"].innerWidth);
    };
    _global["default"].addEventListener('resize', handleResize);
    return function () {
      _global["default"].removeEventListener('resize', handleResize);
    };
  });
  return width;
}

// Hook
// Parameter is the boolean, with default "false" value
var useSwitch = exports.useSwitch = function useSwitch() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  // Initialize the state
  var _useState5 = (0, _react.useState)(initialState),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    on = _useState6[0],
    setState = _useState6[1];

  // Define and memorize toggler function in case we pass down the comopnent,
  // This function change the boolean value to it's opposite value
  var toggle = (0, _react.useCallback)(function () {
    return setState(function (state) {
      return !state;
    });
  }, []);
  var toggleOn = (0, _react.useCallback)(function () {
    return setState(function () {
      return true;
    });
  }, []);
  var toggleOff = (0, _react.useCallback)(function () {
    return setState(function () {
      return false;
    });
  }, []);
  return [on, toggle, toggleOn, toggleOff];
};
function useKeyHack() {
  var _useState7 = (0, _react.useState)(0),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    key = _useState8[0],
    setKey = _useState8[1];
  (0, _react.useEffect)(function () {
    return setKey(1);
  }, []);
  return key;
}
function useForm() {
  var initial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // create a state object for our inputs
  var _useState9 = (0, _react.useState)(initial),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    formData = _useState10[0],
    setFormData = _useState10[1];
  var initialValues = Object.values(initial).join('');
  (0, _react.useEffect)(function () {
    return setFormData(initial);
  }, [initialValues]);
  function handleChange(e) {
    var value = e.target.value;
    var _e$target = e.target,
      name = _e$target.name,
      type = _e$target.type;
    if (type === 'number') {
      value = parseInt(value, 10);
    }
    if (type === 'file') {
      var _e$target$files = (0, _slicedToArray2["default"])(e.target.files, 1);
      value = _e$target$files[0];
    }
    setFormData(_objectSpread(_objectSpread({}, formData), {}, (0, _defineProperty2["default"])({}, name, value)));
  }
  function resetForm() {
    setFormData(initial);
  }
  function clearForm() {
    var blankState = Object.fromEntries(Object.entries(formData).map(function (_ref) {
      var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      return [key, ''];
    }));
    setFormData(blankState);
  }
  return {
    formData: formData,
    handleChange: handleChange,
    resetForm: resetForm,
    clearForm: clearForm
  };
}

// Hook
// Parameter is the boolean, with default "false" value
var useToggle = exports.useToggle = function useToggle() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  // Initialize the state
  var _useState11 = (0, _react.useState)(initialState),
    _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
    on = _useState12[0],
    setState = _useState12[1];

  // Define and memorize toggler function in case we pass down the comopnent,
  // This function change the boolean value to it's opposite value
  var toggle = (0, _react.useCallback)(function () {
    return setState(function (on) {
      return !on;
    });
  }, []);
  return [on, toggle];
};

// Hook that fire function on clicks outside of the passed ref
function useOutsideClick(ref, setShowDropdown) {
  (0, _react.useEffect)(function () {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setShowDropdown(false);
      }
    }
    // Bind the event listener
    document.addEventListener('click', handleClickOutside);
    document.addEventListener('touchend', handleClickOutside);
    return function () {
      // Unbind the event listener on clean up
      document.removeEventListener('click', handleClickOutside);
      document.removeEventListener('touchend', handleClickOutside);
    };
  }, [ref]);
}